import moment from 'moment';

class ReviewController {

    constructor($scope, checkout, basket, markdownService, configService, loginoutService) {
        this.$scope = $scope;
        this.checkout = checkout;
        this.basket = basket;
        this.moment = moment;
        this.markdownService = markdownService;
        this.config = configService;
        this.loginoutService = loginoutService;
    }

    $onInit () {
        this.loading = true;

        return this.basket.promise
            .then(() => {
                if (this.getSetting('cancellation_agreement') && this.getSetting('cancellation_agreement_duration') > 0) {
                    this.basketWithinAgreementWindow = this.moment(this.basket.earliestDate()).diff(this.moment().add(this.getSetting('cancellation_agreement_duration'), 'hours')) < 0;
                    if (this.basketWithinAgreementWindow) {
                        this.basket.contents.cancellation_agreement = false;
                    }
                }

                this.isFirstStep = this.basket.contents.first_step === 'review';
                this.checkout.setStepByName('review');
                this.loading = false;
                this.checkout.saving = false;
            });
    }

    getSetting (field) {
        if (this.content && this.content.settings && this.content.settings[field]) {
            return this.content.settings[field];
        }
    }

    paymentGateway (gateway) {
        return this.config.get('gateways')[gateway];
    }

    isEditing () {
        return this.loginoutService.isEditing();
    }
}

ReviewController.$inject = ['$scope', 'checkout', 'basket', 'markdownService', 'configService', 'loginoutService'];

export default ReviewController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/checkout/controllers/review.controller.js